import React from 'react';
import { Helmet } from 'react-helmet-async';
import { BRAND_NAME, DEFAULT_OG_IMAGE, absoluteUrl } from '../seo';

function PrivacyPolicy() {
  const pageUrl = absoluteUrl('/privacy-policy');
  const pageTitle = 'Privacy Policy';
  const pageDescription = 'Read the Apex Breath privacy policy and how account and usage data are handled.';

  return (
    <section className="basic-page">
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={pageUrl} />
        <meta property="og:title" content={`${pageTitle} | ${BRAND_NAME}`} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={DEFAULT_OG_IMAGE} />
        <meta name="twitter:title" content={`${pageTitle} | ${BRAND_NAME}`} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
      </Helmet>
      <h1>Privacy Policy</h1>
      <p>
        Apex Breath is built to use the minimum personal information needed to deliver the product and improve your
        experience.
      </p>
      <h2>What we collect</h2>
      <p>Account details, subscription status, and app usage information required for app functionality.</p>
      <h2>How we use it</h2>
      <p>To provide core features, maintain your account, and improve app performance.</p>
      <h2>Your control</h2>
      <p>You can request account deletion from inside the app settings at any time.</p>
      <p className="muted">For full legal text, contact: troy@merokeeventures.com</p>
    </section>
  );
}

export default PrivacyPolicy;
